import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Finalmente entiendo qué creatina comprar. Este manual me ahorró miles de pesos en productos que no funcionan.',
    name: 'Facundo',
    age: 28,
    city: 'Buenos Aires',
    rating: 5
  }, {
    quote: 'La información más clara y directa que he encontrado sobre creatina. Sin rodeos, solo ciencia real.',
    name: 'Camila',
    age: 32,
    city: 'Córdoba',
    rating: 5
  }, {
    quote: 'Dejé de tirar plata en marcas caras. Ahora sé exactamente qué buscar y cuánto pagar. Gracias por la verdad.',
    name: 'Martín',
    age: 25,
    city: 'Rosario',
    rating: 5
  }, {
    quote: 'Me sorprendió lo engañado que estaba. Este manual debería ser obligatorio antes de comprar cualquier suplemento.',
    name: 'Valentina',
    age: 30,
    city: 'Mendoza',
    rating: 5
  }, {
    quote: 'Compré creatina "premium" por años. Ahora uso una que cuesta 1/3 y funciona igual. Increíble.',
    name: 'Nicolás',
    age: 27,
    city: 'La Plata',
    rating: 5
  }, {
    quote: 'La lista negra de marcas vale oro. Evité comprar productos que estaba a punto de pedir online.',
    name: 'Florencia',
    age: 29,
    city: 'Mar del Plata',
    rating: 5
  }];
  return <section className="w-full bg-[#0B1C2C] py-20 px-4 sm:px-6 lg:px-8" data-id="element-179">
      <div className="max-w-7xl mx-auto" data-id="element-180">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-181">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-[#F2F4F8] mb-6" data-id="element-182">
            Lo Que Dicen{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#2F6BFF] to-[#7EC8FF]" data-id="element-183">
              Quienes Ya Lo Tienen
            </span>
          </h2>
          <p className="text-xl text-[#F2F4F8]/80 max-w-3xl mx-auto" data-id="element-184">
            Más de 1,500 personas han descubierto la verdad sobre la creatina
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-185">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.05
        }} className="bg-[#132A44] border border-[#2F6BFF]/20 rounded-xl p-6 hover:border-[#2F6BFF]/40 transition-all" data-id="element-186">
              <div className="flex gap-1 mb-4" data-id="element-187">
                {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-188" />)}
              </div>

              <p className="text-[#F2F4F8]/90 mb-6 italic" data-id="element-189">
                "{testimonial.quote}"
              </p>

              <div className="border-t border-[#2F6BFF]/10 pt-4" data-id="element-190">
                <p className="text-[#F2F4F8] font-semibold" data-id="element-191">
                  {testimonial.name}, {testimonial.age}
                </p>
                <p className="text-[#F2F4F8]/60 text-sm" data-id="element-192">{testimonial.city}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-12 text-center" data-id="element-193">
          <div className="inline-flex items-center gap-2 bg-[#2F6BFF]/20 border border-[#2F6BFF]/50 rounded-full px-6 py-3" data-id="element-194">
            <div className="flex -space-x-2" data-id="element-195">
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#2F6BFF] to-[#7EC8FF] border-2 border-[#132A44]" data-id="element-196"></div>
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#7EC8FF] to-[#2F6BFF] border-2 border-[#132A44]" data-id="element-197"></div>
              <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#2F6BFF] to-[#7EC8FF] border-2 border-[#132A44]" data-id="element-198"></div>
            </div>
            <span className="text-[#7EC8FF] font-semibold" data-id="element-199">
              +1,500 personas ya lo tienen
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}